import { render, staticRenderFns } from "./CreateOpenAward.vue?vue&type=template&id=0faa02ea&scoped=true&"
import script from "./CreateOpenAward.vue?vue&type=script&setup=true&lang=js&"
export * from "./CreateOpenAward.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./CreateOpenAward.vue?vue&type=style&index=0&id=0faa02ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0faa02ea",
  null
  
)

export default component.exports